import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import { containerIds } from 'modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { setUIState } from 'modules/ui'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import AccountMenu from 'components/business/shared/AccountMenu'
import Path from 'routes/path'

function HomeHeaderContainer({ ui, data, actions, config, match }) {
  const currentUser = data.viewer

  function showUser(e) {
    e.preventDefault()
    redirectTo(wwwUrl(`/dashboard`))
  }

  function showNotifications(e) {
    e.preventDefault()
    redirectTo(wwwUrl(`/dashboard`))
  }

  function showOverlay(e) {
    e.preventDefault()
    actions.setUIState(containerIds.HOME, {
      isFormOverlayVisible: true,
    })
  }

  function renderLoggedIn() {
    return (
      <header>
        <div className="dashboard-container">
          <div className="business-header clearfix">
            <h1 className="fl">
              <a href="/" className="business-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </h1>
            <AccountMenu
              data={data}
              ui={ui}
              actions={actions}
              config={config}
            />
            <div className="site-header__smp">
              <input
                type="checkbox"
                className="site-header__drawer-check"
                id="site-header__drawer"
              />
              <label
                className="business-header__drawer-menu-btn"
                htmlFor="site-header__drawer"
              >
                <i className="fa fa-bars site-header__search-menu-icon" />
              </label>
              <label
                className="site-header__drawer-close-menu"
                htmlFor="site-header__drawer"
              />
            </div>
            <div
              id="js-search"
              className="site-header__search-sm pc-hide__sm-show"
            />
          </div>
        </div>
      </header>
    )
  }

  function renderAnonymous() {
    return (
      <header>
        <div className="dashboard-container">
          <div className="business-header clearfix">
            <h1 className="fl">
              <a href="/" className="business-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </h1>
            <ul className="site-header__nav sm-hide">
              <li>
                <a
                  href={Path.signupAccount(config.URL || '')}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text mr10 business-header__text">
                    {i18n.t('page.header.registration')}
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={Path.loginAccount(config.URL || '')}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text business-header__text">
                    {i18n.t('page.header.login')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div className="site-header__smp">
            <input
              type="checkbox"
              className="site-header__drawer-check"
              id="site-header__drawer"
            />
            <label
              className="business-header__drawer-menu-btn"
              htmlFor="site-header__drawer"
            >
              <i className="fa fa-bars site-header__search-menu-icon" />
            </label>
            <label
              className="site-header__drawer-close-menu"
              htmlFor="site-header__drawer"
            />
          </div>
          <div
            id="js-search"
            className="site-header__search-sm pc-hide__sm-show"
          />
        </div>
      </header>
    )
  }

  if (currentUser) return renderLoggedIn()
  else return renderAnonymous()
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeHeaderContainer)
